var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFloorplan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6.808,
    width: 28.718,
    height: 71.385,
    rx: 5,
    fill: "#88909F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.141,
    y: 7.308,
    width: 27.718,
    height: 32.641,
    rx: 4.5,
    stroke: "#354767"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82.782,
    y: 7.308,
    width: 27.718,
    height: 32.641,
    rx: 4.5,
    stroke: "#354767"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.141,
    y: 45.051,
    width: 27.718,
    height: 32.641,
    rx: 4.5,
    stroke: "#354767"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82.782,
    y: 45.051,
    width: 27.718,
    height: 32.641,
    rx: 4.5,
    stroke: "#354767"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFloorplan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/floorplan.809ebc14dd44ebc96f6769c57ce2aa63.svg";